import { render, staticRenderFns } from "./Publish.vue?vue&type=template&id=87821d9c&scoped=true&"
import script from "./Publish.vue?vue&type=script&lang=js&"
export * from "./Publish.vue?vue&type=script&lang=js&"
import style0 from "./Publish.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Publish.vue?vue&type=style&index=1&id=87821d9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87821d9c",
  null
  
)

export default component.exports